// Default menu settings configurations

export interface MenuPublicoItem {
    title: string;
    icon: string;
    page: string;
    isExternalLink?: boolean;
    issupportExternalLink?: boolean;
    isStarterkitExternalLink?: boolean;
    badge: { type: string, value: string };
    submenu: {
      items: Partial<MenuPublicoItem>[];
    };
    section: string;
  }
  
  export interface MenuConfig {
    vertical_menu: {
      items: Partial<MenuPublicoItem>[]
    };
  }
  
  export const MenuPublicoSettingsConfig: MenuConfig = {
    vertical_menu: {
      items: [
        { section: 'Portales' },
        {
          title: 'Egresados',
          icon: 'icon-graduation',
          page: '/'
        },
        {
          title: 'Empresas',
          icon: 'la-briefcase',
          page: '/portal-empresa'
        },
        {
          title: 'Docentes',
          icon: 'icon-book-open',
          page: '/portal-docente'
        },
        {
          title: 'Contacto',
          icon: 'feather ft-phone',
          page: '/contacto',
        },
        { section: 'Iniciar sesión:' },
        {
          title: 'Egresado',
          icon: 'icon-login',
          page: '/login'
        },
        {
          title: 'Empresa',
          icon: 'icon-login',
          page: '/login-empresa'
        },
        {
          title: 'Docente',
          icon: 'icon-login',
          page: '/login-docente'
        }
      ]
    }
  
  };
  
  
  
  
  
  